import { RiskRemediationTimeIntervalEnum } from '@/types';
import { riskRemediationTimeInterval as riskRemediationTimeIntervalAtom } from '@/state';
import { enumToString } from '@/utils/string';
import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useAtom } from 'jotai';

const timeIntervalOptions = Object.values(RiskRemediationTimeIntervalEnum).map((interval) => ({
  label: enumToString(interval),
  value: interval,
}));

const styles = {
  '& .MuiSelect-select': {
    padding: 1,
    border: 'none',
  },
  width: '12rem',
};

export const TimeIntervalSwitch = () => {
  const [riskRemediationTimeInterval, setRiskRemediationTimeInterval] = useAtom(
    riskRemediationTimeIntervalAtom
  );

  const handleChange = (event: SelectChangeEvent<string>) => {
    setRiskRemediationTimeInterval(event.target.value as RiskRemediationTimeIntervalEnum);
  };

  return (
    <FormControl>
      <Select sx={styles} size="small" value={riskRemediationTimeInterval} onChange={handleChange}>
        {timeIntervalOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
